"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/*
 * A util for measuring the DOM size of an element that is currently not measurable, either because
 * its display value is 'none' or perhaps height is set to zero, as in the collapsed state of
 * a dropdown widget.
 *
 * `modifyNode` is a function that can be used to modify the cloned element before measuring it,
 * such as removing the display:none property or setting height to auto. Defaults to removing 'hidden'
 * from the classList.
 *
 * `parentNode` may be needed when measuring the height of an element, as the height of flowing content
 * such as text depends on the parent's width and how quickly text wraps. When `parentNode` is provided,
 * that node's width will set the width of this utility's wrapper before measuring.
 */

var removeHiddenClass = function removeHiddenClass(node) {
  node.classList.remove('hidden');
  return node;
};
var _default = exports["default"] = function _default(_ref) {
  var node = _ref.node,
    _ref$modifyNode = _ref.modifyNode,
    modifyNode = _ref$modifyNode === void 0 ? removeHiddenClass : _ref$modifyNode,
    parentNode = _ref.parentNode;
  if (!node) {
    return;
  }
  var wrapperWidth = parentNode ? "".concat(parentNode.getBoundingClientRect().width, "px") : '';
  var clone = node.cloneNode(true); // true for clone deep, ie. include children
  var modifiedClone = modifyNode(clone);
  // Create a div that will hold the cloned element to be measured.
  // It's positioned offscreen and set below stacking layers
  // to prevent capturing any clicks.
  // When an element's visibility is set to hidden, it still displaces space in the layout
  // and can be measured.
  var div = document.createElement('div');
  div.setAttribute('style', "position: absolute; top: 100%; width: ".concat(wrapperWidth, "; z-index: -1; visibility: hidden"));
  div.appendChild(modifiedClone);
  document.body.appendChild(div);
  var width = modifiedClone.clientWidth;
  var height = modifiedClone.clientHeight;

  // cleanup!
  document.body.removeChild(div);
  return {
    width: width,
    height: height
  };
};